import { Address } from './address';
import { Vehicle } from './vehicle';

export type Risk = Address | Vehicle | string;
